export default __webpack_public_path__ + "static/media/guitar.2733200a.png";